import { render, staticRenderFns } from "./SettingsUsersExtraHeader.vue?vue&type=template&id=a1664724&scoped=true"
import script from "./SettingsUsersExtraHeader.vue?vue&type=script&lang=js"
export * from "./SettingsUsersExtraHeader.vue?vue&type=script&lang=js"
import style0 from "./SettingsUsersExtraHeader.vue?vue&type=style&index=0&id=a1664724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1664724",
  null
  
)

export default component.exports